import { HasuraAuthClient, NhostAuthConstructorParams } from '@nhost/hasura-auth-js';

const isBrowser = typeof window !== 'undefined';

export class KaktuAuthClient extends HasuraAuthClient {
  constructor(params: NhostAuthConstructorParams) {
    super({
      ...params,
      autoSignIn: isBrowser && params.autoSignIn,
      autoRefreshToken: isBrowser && params.autoRefreshToken,
      clientStorageType: 'localStorage',
    });
  }
}
